module.exports = __webpack_public_path__ + "img/Credit card at home Icon - charcoal.6305bb65.svg";